<template>
	<div class="PageGroup">
		<transition name="PageGroupTranstion" enter-active-class="animated PageGroupFadeIn">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'PageGroup'
}
</script>



// WEBPACK FOOTER //
// src/pages/PageGroup.vue